import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

const ServiceOnlineOrderPage = () => {
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[6]}
            className={` ${isVisible[6] ? "in_view fade_in" : "fade_in"}`}
          >
            TABLE ORDER
          </h1>
          <h2>
            후불매장도 카운터가 필요없어요.
            <br />
            주문도 결제도 자리에
          </h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage01.png"
            alt="주문서인쇄는 그만! 효율적인 매장 운영이 가능한 kds"
            className="webTableOrder01"
          />
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage01-tableOrder.png"
            alt="kds"
            className="behindTableOreder webView"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              비용 절감
            </h1>
            <h2>주문 과정 자동화로 인건비를 절감할 수 있습니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage02.png"
              alt="주문 과정 자동화로 인건비를 절감할 수 있는 테이블오더"
              className="webTableOrder02"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              간편한 결제
            </h1>
            <h2>직원이 필요 없이 자리에서 간편하게 결제가 가능합니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage03.png"
              alt="직원이 필요 없이 자리에서 간편하게 결제가 가능한 테이블오더"
              className="webTableOrder03"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
            >
              다양한 혜택 적용 가능
            </h1>
            <h2>
              매장 쿠폰을 등록하고,
              <br />
              포인트 적립을 할 수 있습니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage04.png"
              alt="쿠폰, 포인트 적립등 다양한 혜택적용이 가능한 테이블오더"
              className="webTableOrder04"
            />
          </div>
        </div>
        <div className="footerContent">
          <h4>테이블오더가 없으신가요?</h4>
          <h3
            ref={hideRefs[5]}
            className={` ${isVisible[5] ? "in_view fade_in" : "fade_in"}`}
          >
            지금 바로 구매하세요!
          </h3>
          <button>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webTableOrderImage05.png"
              alt="테이블오더"
              className="webTableOrder05"
            />
          </button>
        </div>
      </div>
    </Style>
  );
};

export default ServiceOnlineOrderPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  /* banner */
  .banner {
    width: 100%;
    position: relative;

    .behindTableOreder {
      width: 15%;
      max-width: 307px;
      position: absolute;
      top: 14%;
      right: 24%;
    }
  }

  /* contentWrap */
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 120px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    h1,
    img {
      margin: 0 !important;
    }
  }

  /* footerContent */
  .footerContent {
    text-align: center;
    h3 {
      display: inline-flex;
      padding: 20px 0 60px 0;
      background: linear-gradient(90deg, #4dd2ae 0%, #5096ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
    h4 {
      margin-top: 60px;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 40px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }
        img {
          margin-top: 30px;
        }
      }
    }
    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .webTableOrder01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileTableOrderImage01.png");
    }
    .webTableOrder05 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileTableOrderImage02.png");
    }
  }
`;
